import request from 'store/utils/request';

export const checkProjectNameRequest = (name, account, idNotIn) =>
  request.get('/projects/', {
    params: {
      name__iexact: name,
      account__slug: account,
      ...(idNotIn && { id__not__in: idNotIn }),
    },
  });

export const getProjectsRequest = async (params, requestId = '') => {
  try {
    return await request.get('/projects/', {
      params,
      requestId,
    });
  } catch (error) {
    throw error;
  }
};

export const addProjectRequest = (userAccountSlug, data) =>
  request.post(`/${userAccountSlug}/projects/`, data, {
    timeout: 3 * 60 * 1000,
  });

export const cloneProjectRequest = async (
  projectAccount,
  projectSlug,
  data,
) => {
  try {
    return await request.post(
      `/${projectAccount}/projects/${projectSlug}/clone/`,
      data,
      {
        timeout: 3 * 60 * 1000, // 3 minutes
      },
    );
  } catch (error) {
    throw error;
  }
};

export const importProjectRequest = async (
  userAccountSlug,
  // eslint-disable-next-line @typescript-eslint/camelcase
  { name, account, nlu_file },
) => {
  try {
    const data = new FormData();
    data.append('nlu_file', nlu_file, nlu_file.name);
    data.append('name', name);
    data.append('account', account);

    return await request.post(`${userAccountSlug}/projects/import/`, data, {
      headers: {
        'Content-Type': `multipart/form-data; boundary=${data._boundary}`,
      },
      timeout: 3 * 60 * 1000,
    });
  } catch (error) {
    throw error;
  }
};
